// NG2
import { Component } from '@angular/core';

@Component({
  selector: 'novo-table-footer',
  template: '<ng-content></ng-content>',
})
export class NovoTableFooterElement {}
